import type { ComboState } from "../simulation/snapshot";
import { CHAIN_WINDOW_S } from "../simulation/scoring";

/** Combo drain ring around the score readout + kill-confirm pulse. */
export class ComboMeter {
  private lastChain = 0;
  private pulseUntil = 0;

  public constructor(
    private readonly root: HTMLElement,
    private readonly tag: HTMLElement,
  ) {}

  public sync(combo: ComboState): void {
    const active = combo.chainCount >= 2 && combo.chainTimer > 0;
    this.root.dataset.active = active ? "true" : "false";

    if (combo.chainCount > this.lastChain && combo.chainCount >= 2) {
      this.pulseUntil = performance.now() + (combo.chainCount % 5 === 0 ? 280 : 140);
      this.root.dataset.pulse = "true";
    }
    this.lastChain = combo.chainCount;
    if (performance.now() > this.pulseUntil) {
      delete this.root.dataset.pulse;
    }

    if (!active) {
      this.root.style.removeProperty("--drain");
      this.tag.hidden = true;
      return;
    }
    const drainPct = (combo.chainTimer / CHAIN_WINDOW_S) * 100;
    this.root.style.setProperty("--drain", `${drainPct}%`);
    this.tag.hidden = false;
    this.tag.textContent = `×${combo.comboMultiplier.toFixed(2)} CH${combo.chainCount}`;
  }
}
